import {Expand} from '@esgi/ui/icons';
import {styled} from '@esgi/ui/theme';

export const ArrowTop = styled(Expand, {
	transform: 'rotateX(180deg)',
});